import Column from '@amzn/meridian/column'
import Loader from '@amzn/meridian/loader'
import React from 'react'
import Text from '@amzn/meridian/text'
import { useBundle } from '@amzn/react-arb-tools'
import { BUNDLE_NAME } from '@src/constants'
import { t } from '@src/translationHelper'

const ATLoader = (): React.ReactElement => {
    const [bundle] = useBundle(BUNDLE_NAME)

    return (
        <Column alignmentHorizontal={'center'}>
            <Loader type="circular" size="medium" />
            <Text>{t(bundle, 'jsma-web-common-loading')}</Text>
        </Column>
    )
}

export default ATLoader
